import type { DuesRepository } from '@zetyar/data-contracts'
import { createSupabaseDuesRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webDuesRepository: DuesRepository = createSupabaseDuesRepository(getSupabaseClient())
